/**
 * <h3>原生方法库</h3> 
 * 原生方法库是采用原生及普通方法的一个混合,便于在debug中随时切换
 * <h5>数据交互</h5>
 * {{#crossLink "bui.ajax"}}{{/crossLink}}: 数据请求 <br>
 * {{#crossLink "bui.checkVersion"}}{{/crossLink}}: 获取最新版本 <br>
 * <h5>页面交互</h5>
 * {{#crossLink "bui.load"}}{{/crossLink}}: 页面跳转及传参 <br>
 * {{#crossLink "bui.getPageParams"}}{{/crossLink}}: 页面获取参数 <br>
 * {{#crossLink "bui.back"}}{{/crossLink}}: 页面后退 <br>
 * {{#crossLink "bui.refresh"}}{{/crossLink}}: 页面刷新 <br>
 * 
 * @module Native
 */
;(function (ui,$) {
    

    /**
     * 数据请求
     * @namespace  bui
     * @class  ajax
     * @constructor 
     * @param {object} option 
     *   @param {string} option.url [请求的地址]
     *   @param {object} option.data [传输的数据对象]
     *   @param {string} [option.method] [传输的方法 GET | POST]
     *   @param {string} [option.dataType] [默认 json | jsonp | script | xml | html | text]
     *   @param {string} [option.contentType] [默认 'text/html;charset=UTF-8' | 'application/x-www-form-urlencoded']'
     *   @param {number} [option.timeout] [超出这个时间则认为请求失败]
     * @example
     *     bui.ajax({
     *         url: "",
     *         data: {}
     *     }).done(function(res){
     *         console.log(res)
     *     }).fail(function(res){
     *         console.log("fail");
     *     })
     * 
     */
    ui.ajax = function (params) {

        //延时处理
        var def = $.Deferred();
        var ajaxHandle;
            params = params || {};
            params.data = params.data || {};
            params.method = params.method || "GET";
            params.dataType = params.dataType || "json";
            params.timeout = params.timeout || 20000;
            params.headers = params.headers || {};
            params.processData = params.processData == false ? false : true;
            params.mimeType = params.mimeType || "none";
            params.cache = params.cache == false ? false : true;
            if (typeof(params.async) == "undefined") {
                params.async = true;
            }
            // 如果没传contentType 就根据不同的请求给予默认的参数值
            if ( params.method == "GET" && (params.contentType === undefined || params.contentType === "") ){
                params.contentType = "text/html;charset=UTF-8";
            }else if( params.method == "POST" && (params.contentType === undefined || params.contentType === "") ){

                params.contentType = "application/x-www-form-urlencoded";
            }else{
                params.contentType = params.contentType;
            }

            // 采用web方式请求
            if ( this.debug || typeof cordova === 'undefined' || params.native == false ) {
                ajaxHandle = $.ajax({
                    async: params.async,
                    url: params.url,
                    data: params.data,
                    type: params.method,
                    dataType: params.dataType,
                    headers : params.headers,
                    contentType: params.contentType,
                    timeout: params.timeout,
                    processData: params.processData,
                    mimeType: params.mimeType,
                    cache: params.cache,
                    success: function(res,status,xhr) {
                        var obj;
                        if( typeof res == 'string'){
                            try{
                                obj = JSON.parse(res);
                            }catch(e){
                                obj = res;
                            }
                        }else{
                            obj = res || {};
                        }
                        def.resolve(obj,status,xhr);
                    },
                    error: function(res,status,xhr) {

                        var obj;
                        if( typeof res == 'string'){
                            try{
                                obj = JSON.parse(res);
                            }catch(e){
                                obj = res;
                            }
                        }else{
                            obj = res || {};
                        }
                        def.reject(obj,status,xhr);
                    }
                })

            } else {

                // 原生请求暂无 abort 阻止请求方法,所以会导致list 多次重复请求问题. 
                var successCallback = function(res,status,xhr) {

                    var result;
                    var obj;
                        if( typeof res == 'string'){
                            try{
                                result = JSON.parse(res);
                            }catch(e){
                                result = res;
                            }
                        }else{
                            result = res || {};
                        }
                    //bt 包多一层returnValue
                        if( typeof result["returnValue"] == 'string'){
                            try{
                                obj = JSON.parse(result["returnValue"]);
                            }catch(e){
                                obj = result["returnValue"];
                            }
                        }else{
                            obj = result["returnValue"] || {};
                        }
                        def.resolve(obj,status,xhr);
                };
                var failCallback = function(res,status,xhr) {
                    var result;
                    var obj;
                        if( typeof res == 'string'){
                            try{
                                result = JSON.parse(res);
                            }catch(e){
                                result = res;
                            }
                        }else{
                            result = res || {};
                        }
                    //bt 包多一层returnValue
                        if( typeof result["returnValue"] == 'string'){
                            try{
                                obj = JSON.parse(result["returnValue"]);
                            }catch(e){
                                obj = result["returnValue"];
                            }
                        }else{
                            obj = result["returnValue"] || {};
                        }
                    def.reject(obj,status,xhr);
                }
                // ajaxHandle = app.ajax({
                //     "url": params.url, 
                //     "data": params.data,
                //     "async": params.async ,
                //     "method": params.method ,
                //     "headers" : params.headers,
                //     "contentType": params.contentType ,
                //     "dataType": params.dataType,
                //     "processData": params.processData,
                //     "mimeType": params.mimeType,
                //     "cache": params.cache,
                //     "timeout": params.timeout ,
                //     "success": successCallback,
                //     "fail": failCallback 
                // });
                
                Cordova.exec(successCallback, failCallback, "HttpRequest", "ajax", [ params.url, params.data, params.method, params.async, params.contentType, params.headers, params.timeout, params.dataType, params.processData, params.cache, params.mimeType ]);
            };

            //中断请求
            def.abort = function(){
                ajaxHandle&&ajaxHandle.abort();
            };

        return def;

    };

    /**
     * 页面跳转可以传参 获取参数请看 {{#crossLink "bui.getPageParams"}}{{/crossLink}} 方法
     * @namespace  bui
     * @class  load
     * @constructor 
     * @param {object} option 
     *   @param {string} option.url 请求的地址
     *   @param {object} option.param 传过去另外页面的参数
     * @example
     *     bui.load({ 
     *         url: "",
     *         param:{}
     *     })
     * 
     */
    ui.load = function (params) {

        var newurl, param;

        if (!params) {
            ui.hint("should be object like {url:'http://domain',params:{....}}");
            return;
        }
        if (!params.url) {
            ui.hint("url is necessary!");
            return;
        }



        //传过去目标页面的值
        param = params.param ;

        //如果开启调试,使用url的方式传值
        if( this.debug || typeof cordova === 'undefined' || params.native == false ){

            newurl = ui.setUrlParams(params.url,param);

            window.location.href = newurl ;

        }else{

            app.load({
                url: params.url ,
                params: param
            });
        }
    };

    /**
     * 获取页面参数,配合 {{#crossLink "bui.load"}}{{/crossLink}} 使用
     * @namespace  bui
     * @class  getPageParams
     * @constructor 
     * @param {function} callback 数据都在回调里面
     * @example
     *     bui.getPageParams(function(res){
     *         var urlparam = res;
     *
     *          console.log(urlparam) //{}
     *     });
     * 
     */
    ui.getPageParams = function (option) {

        var callback,
            native;
        if( typeof option === "function"){
            callback = option || function() {};
            native = true ;
        }else if( option && option.callback ){
            callback = option.callback || function() {};
            native = option.native ;
        }
        
        //如果开启调试,使用url的方式取值
        if( this.debug || typeof cordova === 'undefined' || native == false ){
            
            var params = this.getUrlParams();
            
            callback && callback(params);

        }else {

            callback && app.getPageParams(callback)
        }
    };
    /**
     * 后退, 原生可以使用回调,pc调试只能在当前页面触发回调
     * @namespace  bui
     * @class  back
     * @constructor 
     * @param {function} callback 在后退的页面触发
     * @example
     *     bui.back();
     * 
     */
    ui.back = function (option) {

        var callback,
            native;
        if( typeof option === "function"){
            callback = option || function() {};
            native = true ;
        }else if( option && option.callback ){
            callback = option.callback || function() {};
            native = option.native ;
        }
        if( this.debug || typeof cordova === 'undefined' || native == false ){

            //pc不能在后退以后执行操作
            window.history.back();
            
        }else{
            //后退以后的页面执行
            app.back(callback);
        }
        
    };
    /**
     * 刷新页面
     * @namespace  bui
     * @class  refresh
     * @constructor 
     * @example
     *     bui.refresh();
     * 
     */
    ui.refresh = function (option) {
        
        var native = option && option.native ;
        if( this.debug || typeof cordova === 'undefined' || native == false ){
            //PC调试无法回调
            window.location.reload();
        }else{
            app.refresh();
        }
    }


    /**
     * 打开文件
     * @namespace  bui
     * @class  run
     * @param {id} string [应用的id,如果是"http://"则打开浏览器]
     * @param {data} {} [启动参数]
     * @constructor 
     * @example
     *     bui.run("http://eid.bingosoft.net:82/bui/demo/api/");
     * 
     */
    ui.run = function (id,data) {

        var data = data || {};

        if( this.debug || typeof cordova === 'undefined' ){
            if( String(id).indexOf("http://") > -1 ){
                var newurl = ui.setUrlParams(id,data);
                var open_link = window.open('', '_newtab');
                    open_link.location = newurl;
            }
        }else{
            app.run(id,data);
        }
    }

    /**
     * <h3>检查版本更新</h3>
     * <p>需要把对应的<a href="http://eid.bingosoft.net:82/bui/demo/json/versionUpdate.json" target="_blank">versionUpdate.json</a> 放到服务器,然后通过修改里面的值来进行检测更新</p>
     * <h5>versionUpdate.json 文件说明: </h5><br>
     * {<br>
            "versionName": "1.0",          //版本名称<br>
            "versionCode": 20160605,       //版本ID<br>
            "minVersionCode": 20160604,    //最小版本号<br>
            "isForced": true,              //是否强制更新,如果强制更新,需要检测最小版本号<br>
            "downloadUrl": "",             //下载的地址<br>
            "remark": "版本更新的内容"        //新版本的描述,支持html<br>
        }<br>
     * @namespace  bui
     * @class  checkVersion
     * @requires confirm
     * @param {string} option 
     * @param {string} option.url [请求更新的地址]
     * @param {object} [option.data] [是否需要传参]
     * @param {string} [option.id] [控件的id,有id会绑定它的点击检查更新事件]
     * @param {string} [option.target] [圆点要放在哪个位置,可以使用ID,独立一个位置,默认在i标签下]
     * @param {string} [option.title] [对话框提醒的标题]
     * @param {string} [option.url] [请求地址]
     * @param {object} [option.data] [请求接口需要的参数]
     * @param {string} [option.method] [请求的方法 GET | POST ]
     * @param {number} [option.timeout] [超时 20000]
     * @param {object} [option.tips] 
     * @param {string} [option.tips.nowVersion] [当前是最新版本的提醒,默认提醒会有版本号]
     * @param {string} [option.tips.minVersion] [版本太低需要强制更新的提醒]
     * @param {string} [option.tips.fail] [网络请求失败的提醒]
     * @param {function} [option.callback] [点击按钮以后是否还有其它业务处理]
     * @constructor 
     * @example
     *     bui.checkVersion({
     *         id: "#checkUpdate",
     *         url: "http://eid.bingosoft.net:82/bui/json/versionUpdate.json"
     *     });
     * 
     */
    ui.checkVersion = function (option) {

        //默认配置
        var config = { 
            id: "",
            target: "i",
            title: "版本更新",
            tips: {
                nowVersion: "",    //当前是最新版本的提醒
                minVersion: "您的版本太低,需要卸载安装最新版才能正常使用!", //版本低于最小版本的提醒
                fail: "网络超时,请检测网络再次尝试"
            },
            url: "",
            data: {},
            method: "GET",
            timeout: 20000,
            callback: null     
        }; 
            option = option || {};

        var param = $.extend( true, config, option );
        
        var url = param.url || "",
            json = param.data || {},
            badges = '<span class="bui-badges"></span>', 
            $id = ui.obj(param.id),
            $target = param.target.indexOf("#") > -1 ? ui.obj(param.target): ( $id ? $id.find(param.target): null);

        //控件
        var dialog = ui.confirm; 

        //添加圆点
        var appendBages = function appendBages () {

            var length = $target ? $target.find(".bui-badges").length: 1;

            if( !length ){
                $target.append(badges);
            }
        }
        //删除圆点
        var removeBages = function removeBages () {
            $target ? $target.find(".bui-badges").remove(): "";
        }

        if( this.debug || typeof cordova === 'undefined' ){

            ui.hint("检测版本, 需要在手机端才能使用!");

        }else{

            app.getInfo(function (result) {

                ui.ajax(param).done(function (res) {

                    var data;
                    if( typeof res === "object"){
                        data = res;
                    }else if( typeof res === "string"){
                        data = JSON.parse(res);
                    }
                        //服务器版本信息
                    var newVersionName = data.versionName,
                        newVersion = parseInt(data.versionCode),
                        minVersion = parseInt(data.minVersionCode),
                        downloadUrl = data.updateUrl || "",
                        //当前版本编码
                        nowVersion = parseInt(result.versionCode),
                        //版本更新提醒
                        tooLowTips = param.tips.minVersion ,
                        nowTips = param.tips.nowVersion || "您目前的版本"+result.versionName+",已经是最新了 ^_^",
                        newTips = data.remark || "检测到新版本"+ newVersionName +",是否立即下载";

                    // 是否强制更新
                    if( data.isForced ){

                        if( nowVersion < minVersion ){
                            appendBages();
                            
                            dialog({
                                 title: param.title,
                                 content: tooLowTips,
                                 always: true,
                                 autoClose: false,
                                 buttons: ["立即下载"],
                                 callback: function () {
                                    try{
                                        // 更新
                                        app.run(downloadUrl)
                                    }catch(e){};
                                 }
                            });

                        }else if( nowVersion > minVersion && nowVersion < newVersion ){
                            
                            appendBages();

                            dialog({
                                 title: param.title,
                                 content: remark,
                                 buttons: ["残忍拒绝","立即下载"],
                                 callback: function () {
                                    var text = $(this).text();
                                        if( text == "立即下载"){

                                            app.run(downloadUrl);
                                        };
                                 }
                            });

                        }else{

                            removeBages();
                            bui.hint(nowTips);
                        }
                    }else{
                        //没有强制更新则新增红点提醒
                        if( nowVersion < newVersion  ){
                            appendBages();
                        }else{
                            removeBages();
                        }
                    }

                    if( $id ){

                        $id.on('click',function () {
                            if( nowVersion < newVersion  ){

                                appendBages();

                                dialog({
                                     title: "新版本"+newVersionName,
                                     content: newTips,
                                     buttons: ["残忍拒绝","立即下载"],
                                     callback: function () {
                                        var text = $(this).text();
                                        if( text == "立即下载"){

                                            app.run(downloadUrl);
                                        };
                                     }
                                });
                            }else{
                                removeBages();
                                bui.hint(nowTips);
                            }

                            param.callback && param.callback.call(this);
                        }); 
                    }

                    
                }).fail(function (argument) {
                    ui.hint( param.tips.fail );
                }); 

            })
        }

    };

    

    // //下载
    // ui.download = function (option) {
    //     var config = {
    //         url: "",
    //         data: {},
    //         fileName:"",
    //         method: "GET",
    //         headers: {},
    //         showProgress: true,
    //         timeout: 20000,
    //         native: true,
    //         onProgress: null,
    //         onSuccess: null,
    //         onFail: null
    //     }

    //     var params = $.extend(true,{},config,option);

    //     var uiLoading,
    //         uiAjax,
    //         //fileData 是一个对象 document.getElementById('fileToUpload').files
    //         targetUrl = params.url,
    //         showProgress = params.showProgress,
    //         onProgress = params.onProgress,
    //         onSuccess = params.onSuccess,
    //         onFail = params.onFail,
    //         progressPercent;

    //         uiLoading = bui.loading();

    //     if ( ui.debug || typeof cordova === 'undefined' || params.native == false ) {
    //     // web下载
    //         // 重置参数
    //         params.cache = false;
    //         params.contentType = false;
    //         params.processData = false;
    //     // 
    //         uiAjax = $.ajax({
    //             url: targetUrl,
    //             type: params.method,
    //             data: params.data,
    //             cache: params.cache,
    //             headers: params.headers,
    //             contentType: params.contentType,    //不可缺
    //             processData: params.processData,    //不可缺
    //             timeout: params.timeout,
    //             xhr: function () {
    //                 var xhr = $.ajaxSettings.xhr();

    //               if (xhr.ontimeout){
    //                 xhr.ontimeout = function (res) {
    //                   params.onTimeout && params.onTimeout(res);
    //                 }
    //               }
    //                 // 处理上传的进度
    //     　　　　　　if(onprogress && xhr) {
    //     　　　　　　　　xhr.addEventListener("progress" , onprogress, false);
    //     　　　　　　　　return xhr;
    //     　　　　　　}
    //             },
    //             success:function(result){

    //                 showProgress && stopLoading();

    //                 onSuccess && onSuccess(result);
    //             },
    //             fail: function (result) {
    //                 showProgress && stopLoading();

    //                 onFail && onFail(result);
    //             }
    //         });

    //     }else{
    //     // 原生的下载
    //         targetUrl = encodeURI(params.url);

    //         //下载路径
    //         var file = cordova.file.documentsDirectory;
    //           //保存路径
    //        fileURL=encodeURI(file+params.fileName);
  
    //         //下载进度                                  
    //         fileTransfer.onprogress = onprogress;

    //         fileTransfer.download( targetUrl, fileURL, function(entry) {
    //                 console.log("download complete: " + entry.toURL());
    //                 console.log("download complete: " + entry.fullPath );
    //              }, function(error) {
    //                  console.log("download error source " + error.source);
    //                  console.log("download error target " + error.target);
    //                  console.log("upload error code" + error.code);
    //              }, false, {
    //                 headers: params.headers
    //              }
    //         );
                               
    //     }

    //     // web 下载进度
    //     function onprogress(evt) {

    //         if (evt.lengthComputable) {

    //             var percentComplete = Math.round(evt.loaded * 100 / evt.total);
    //             progressPercent = percentComplete.toString() + '%';

    //             showProgress && startLoading(progressPercent);
                
    //             onProgress && onProgress(progressPercent);
    //         }
    //     }

    //     // 开启进度
    //     function startLoading(percent) {
    //         uiLoading &&  uiLoading.start({
    //             text : percent
    //         });
    //     }

    //     // 关闭进度
    //     function stopLoading() {
    //         uiLoading &&  uiLoading.stop();
    //     }


    // };

    return ui;

})( bui || {}, libs );
